{
  "platform": {
    "create": {
      "formExamples": {
        "nameEn": "Example Retail Group",
        "nameAr": "مجموعة متاجر المثال",
        "slug": "example-retail",
        "adminName": "مثال: مسؤول المنشأة",
        "adminEmail": "administrator@example.test"
      },
      "notAvailableTitle": "غير متاح لدورك",
      "notAvailableBody": "يتطلب إنشاء منشأة ودعوة مسؤولها الأول دورًا يتضمّن صلاحية إعداد المنشآت.",
      "refusedTitle": "لم تُنشأ المنشأة",
      "missing": {
        "nameEn": "أدخل اسم المنشأة بالإنجليزية.",
        "nameAr": "أدخل اسم المنشأة بالعربية.",
        "slug": "أدخل المعرّف.",
        "adminName": "أدخل اسم المسؤول.",
        "adminEmail": "أدخل البريد الإلكتروني للمسؤول."
      }
    },
    "org": {
      "invitationState": {
        "expired": "انتهت صلاحية الدعوة",
        "revoked": "أُلغيت الدعوة",
        "none": "لا توجد دعوة مسجّلة"
      },
      "invitationExpiredOn": "انتهت صلاحية الدعوة في",
      "historyLatest": "تُعرض أحدث {{count}} من الأحداث",
      "historyOlder": "عرض الأحداث الأقدم"
    },
    "pilotStatus": {
      "planned": "مخطط",
      "configuring": "قيد الإعداد",
      "ready": "جاهز",
      "live": "مباشر",
      "completed": "مكتمل",
      "converted": "محوّل",
      "expired": "منتهي",
      "cancelled": "ملغى"
    },
    "subscriptionStatus": {
      "draft": "مسودة",
      "active": "نشط",
      "past_due": "متأخر",
      "suspended": "موقوف",
      "cancelled": "ملغى",
      "expired": "منتهي"
    },
    "orgs": {
      "allAdministrators": "كل المسؤولين",
      "pendingActivation": "لم يُفعّل الحساب بعد"
    },
    "controlPlane": {
      "scope": "الإدارة التجارية وجاهزية المنشآت. تبقى مشتريات العملاء في بوابتهم الخاصة.",
      "plans": "الخطط",
      "subscriptions": "الاشتراكات",
      "capacity": "الصلاحيات التجارية والسعة",
      "addons": "الإضافات",
      "commercial": "الإدارة التجارية",
      "operations": "عمليات الدعم",
      "audit": "سجل التدقيق",
      "noAccess": "دورك لا يتيح الوصول إلى هذا القسم.",
      "pinned": "الإصدارات المنشورة ثابتة. تحتفظ الاشتراكات بإصدارها المحدد حتى تطبيق تغيير معتمد.",
      "editPlan": "تعديل الخطة",
      "createPlan": "إنشاء خطة",
      "planDefinition": "تعريف الخطة",
      "retire": "إيقاف إتاحة الخطة",
      "activate": "تفعيل الخطة",
      "active": "نشطة",
      "retired": "غير متاحة",
      "versions": "الإصدارات",
      "newVersion": "إصدار مسودة جديد",
      "version": "الإصدار {{version}}",
      "published": "منشور",
      "draft": "مسودة",
      "editVersion": "تعديل المسودة",
      "publish": "نشر الإصدار",
      "searchPlans": "البحث في الخطط",
      "emptyFiltered": "لا توجد سجلات مطابقة",
      "noPlans": "لا توجد خطط",
      "code": "الرمز",
      "planUpdated": "حُدّثت الخطة: {{name}}.",
      "versionPublished": "نُشر الإصدار {{version}}. تبقى الاشتراكات الحالية دون تغيير.",
      "priceUnspecified": "السعر غير محدد",
      "savePlan": "حفظ الخطة",
      "planSaved": "حُفظت الخطة: {{name}}.",
      "publicPlan": "ظاهرة في دليل الخطط العام",
      "required": "هذا الحقل مطلوب.",
      "refused": "تعذّر حفظ التغيير",
      "reason": "السبب",
      "reasonRequired": "أدخل سبب هذا التغيير.",
      "reasonPlaceholder": "اشرح سبب الحاجة إلى هذا التغيير التجاري.",
      "planCodeHint": "استخدم الأحرف الإنجليزية أو الأرقام أو الشرطات أو الشرطات السفلية.",
      "formExamples": {
        "code": "PLAN-EXAMPLE",
        "name_en": "Example Growth Plan",
        "name_ar": "مثال: خطة النمو",
        "description_en": "A plan for organisations with multiple purchasing units.",
        "description_ar": "خطة للمنشآت التي تضم وحدات شراء متعددة."
      },
      "currency": "العملة التجارية",
      "basePrice": "السعر الأساسي",
      "billingPeriod": "دورية الفوترة",
      "saveVersion": "حفظ المسودة",
      "entitlements": "المزايا التجارية",
      "notImplemented": "الإمكانات التقنية غير متاحة",
      "implemented": "الإمكانات التقنية متاحة",
      "enabled": "مشمولة",
      "disabled": "غير مشمولة",
      "limit": "الحد",
      "capacityMeaning": "تُحتسب السعة التجارية على وحدات الشراء النشطة. توسّع الإضافات الحدود بأكبر حد منطبق، دون جمع الحدود.",
      "assignSubscription": "تعيين اشتراك",
      "searchSubscriptions": "البحث في الاشتراكات",
      "filterSubscriptions": "تصفية الاشتراكات",
      "context": "السياق التجاري",
      "selectedRecord": "السجل المحدد",
      "noSubscriptions": "لا توجد اشتراكات",
      "subscriptionUpdated": "حُدّث الاشتراك",
      "suspendSubscription": "تعليق الاشتراك",
      "reinstateSubscription": "إعادة تفعيل الاشتراك",
      "accessNow": "الوصول الآن",
      "available": "متاح",
      "unavailable": "غير متاح",
      "contract": "العقد",
      "noContract": "لا يوجد عقد مرتبط",
      "changePlan": "تغيير الخطة",
      "adjustCapacity": "تعديل السعة",
      "commercialVsTechnical": "الشمول التجاري لا يعني توفر الإمكانات التقنية. يُعرض كل منهما على حدة.",
      "changes": "طلبات التغيير",
      "approveChange": "اعتماد التغيير",
      "applyChange": "تطبيق التغيير",
      "cancelChange": "إلغاء التغيير",
      "subscriptionStateEffect": "يغيّر هذا الإجراء الوصول عبر الاشتراك. تُدار حالة المنشأة بشكل مستقل.",
      "authoritativeMoment": "يحدد النظام موعد النفاذ. تنتظر التخفيضات التجديد، وتتطلب التغييرات المعلّقة استيفاء الشروط القائمة.",
      "before": "قبل",
      "previousSubscription": "الاشتراك السابق",
      "after": "بعد",
      "proposed": "المقترح",
      "held": "هذا التغيير معلّق. راجع شروطه التجارية قبل التطبيق.",
      "wholeCapacity": "أدخل عددًا صحيحًا من 0 إلى 2147483647.",
      "targetCapacity": "السعة المقترحة",
      "reviewChange": "مراجعة التغيير",
      "proposeChange": "إرسال طلب التغيير",
      "versionLabel": "إصدار الخطة المنشور",
      "activeContractOnly": "اختر عقدًا ساريًا لهذه المنشأة وغير مرتبط باشتراك آخر.",
      "operationsReadOnly": "حالة المجدول وتشغيلاته من سجلات العمليات القائمة. لا تُعرض سجلات مشتريات العملاء.",
      "scheduler": "المجدول",
      "schedulerAlive": "المجدول يرسل حالته",
      "schedulerMissing": "لم يرسل المجدول حالته مؤخرًا",
      "noTasks": "لا توجد مهام للمجدول",
      "task": "المهمة",
      "health": "الحالة التشغيلية",
      "lastSuccess": "آخر نجاح",
      "nextRun": "التشغيل التالي المتوقع",
      "runHistory": "سجل التشغيلات",
      "noRuns": "لا توجد تشغيلات مسجلة",
      "recordsChanged": "السجلات المتغيرة",
      "auditScope": "أحداث الإدارة التجارية وإدارة المنصة مع إخفاء البيانات بحسب صلاحيات النظام. مشتريات العملاء خارج هذا العرض.",
      "periodLabel": "الفترة الزمنية للأحداث",
      "noAudit": "لا توجد أحداث في هذا النطاق",
      "action": "الإجراء",
      "occurred": "وقت الحدث",
      "actor": "منفّذ الإجراء",
      "system": "النظام",
      "platformGlobal": "على مستوى المنصة",
      "noReason": "لم يُسجّل سبب",
      "addonUpdated": "حُدّثت الإضافة: {{name}}.",
      "effectiveNow": "نافذة الآن",
      "notEffectiveNow": "غير نافذة الآن",
      "searchAddons": "البحث في الإضافات",
      "noAddons": "لا توجد إضافات",
      "noVersions": "لا توجد إصدارات",
      "noChanges": "لا توجد طلبات تغيير",
      "noEntitlements": "لا توجد مزايا تجارية",
      "addon": "الإضافة",
      "commercialAvailability": "الإتاحة التجارية",
      "technicalAvailability": "الإتاحة التقنية",
      "sellable": "متاحة للاشتراك",
      "notSellable": "غير متاحة للاشتراك",
      "subscribedAddons": "الإضافات المشترك بها",
      "attachAddon": "إضافة اشتراك بإضافة",
      "noAssignments": "لا توجد إضافات معيّنة",
      "scheduleRemoval": "جدولة الإزالة",
      "chooseOrganisation": "اختر منشأة لعرض إضافاتها.",
      "removalAtRenewal": "تسري الإزالة عند التجديد، ويستمر الوصول الحالي حتى الموعد الذي يحدده النظام.",
      "coterminousAddon": "يجب أن تقع مدة الإضافة ضمن مدة الاشتراك الرئيسي. تستخدم التواريخ الفارغة تلك المدة.",
      "currentOrganisation": "صلاحيات المنشأة وسعتها الحالية",
      "historicalScope": "هذا اشتراك سابق. تخص الخطة والعقد هذا السجل، بينما تصف الصلاحيات والسعة حالة المنشأة الحالية.",
      "includedCapacity": "السعة المشمولة",
      "allocatedCapacity": "السعة المخصصة",
      "admin": "مسؤول المنشأة",
      "readiness": "الجاهزية",
      "ready": "جاهزة",
      "needsSetup": "تحتاج إلى إعداد",
      "filterOrganisations": "تصفية المنشآت",
      "suspendOrganisation": "تعليق المنشأة",
      "reinstateOrganisation": "إعادة تفعيل المنشأة",
      "organisationStateEffect": "يغيّر هذا الإجراء حالة المنشأة والوصول إليها دون تغيير اشتراكها أو شروطها التجارية.",
      "organisationUpdated": "حُدّثت المنشأة",
      "missingData": "المعلومات الحالية غير متاحة بعد.",
      "existingSubscription": "لهذه المنشأة اشتراك قائم. استخدم مسار تغيير الاشتراك.",
      "allocatedUnits": "وحدات الشراء المخصصة",
      "usedUnits": "وحدات الشراء النشطة",
      "unlimitedOrganisations": "المنشآت دون حد: {{count}}",
      "needsSetupCount": "منشآت تحتاج إلى إعداد",
      "capacityDefinition": "تُحتسب السعة المحدودة بصورة مستقلة عن المنشآت دون حد للسعة.",
      "fields": {
        "code": "رمز الخطة",
        "name_en": "الاسم بالإنجليزية",
        "name_ar": "الاسم بالعربية",
        "description_en": "الوصف بالإنجليزية",
        "description_ar": "الوصف بالعربية"
      },
      "period": {
        "unspecified": "الدورية غير محددة",
        "annual": "سنوية",
        "monthly": "شهرية"
      },
      "contexts": {
        "pilot": "تجريبي",
        "layer1": "الطبقة الأولى",
        "custom": "مخصص"
      },
      "subscriptionStatus": "حالة الاشتراك"
    }
  }
}
